import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { ProducerSettings } from "@/hooks/useProducerSettings";

interface Props {
  settings: ProducerSettings;
  onUpdate: (updates: Partial<ProducerSettings>) => void;
}

export function ProducerNotificationSettings({ settings, onUpdate }: Props) {
  return (
    <Card className="space-y-6 p-6">
      <div>
        <h2 className="mb-2 text-xl font-semibold">Notification settings</h2>
        <p className="text-sm text-muted-foreground">
          Configure which notifications crew members receive and when.
        </p>
      </div>

      <div className="space-y-4">
        <h3 className="font-medium">Push notification types</h3>

        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <Label htmlFor="notify_new" className="flex-1 cursor-default">
              New assignment notifications
            </Label>
            <Switch
              id="notify_new"
              checked={settings.notify_new_assignment}
              onCheckedChange={(checked) => onUpdate({ notify_new_assignment: checked })}
            />
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="notify_updated" className="flex-1 cursor-default">
              Updated assignment notifications
            </Label>
            <Switch
              id="notify_updated"
              checked={settings.notify_updated_assignment}
              onCheckedChange={(checked) => onUpdate({ notify_updated_assignment: checked })}
            />
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="notify_deleted" className="flex-1 cursor-default">
              Assignment deleted notifications
            </Label>
            <Switch
              id="notify_deleted"
              checked={settings.notify_deleted_assignment}
              onCheckedChange={(checked) => onUpdate({ notify_deleted_assignment: checked })}
            />
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="notify_soon" className="flex-1 cursor-default">
              Starting-soon reminders
            </Label>
            <Switch
              id="notify_soon"
              checked={settings.notify_starting_soon}
              onCheckedChange={(checked) => onUpdate({ notify_starting_soon: checked })}
            />
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="notify_announce" className="flex-1 cursor-default">
              General producer announcements
            </Label>
            <Switch
              id="notify_announce"
              checked={settings.notify_announcements}
              onCheckedChange={(checked) => onUpdate({ notify_announcements: checked })}
            />
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="notify_location" className="flex-1 cursor-default">
              Location-based alerts
            </Label>
            <Switch
              id="notify_location"
              checked={settings.notify_location_alerts}
              onCheckedChange={(checked) => onUpdate({ notify_location_alerts: checked })}
            />
          </div>

          <div className="flex items-center justify-between">
            <Label htmlFor="notify_weather" className="flex-1 cursor-default">
              Weather &amp; rain alerts
            </Label>
            <Switch
              id="notify_weather"
              checked={settings.notify_weather}
              onCheckedChange={(checked) => onUpdate({ notify_weather: checked })}
            />
          </div>
        </div>
      </div>
    </Card>
  );
}
